import { render, staticRenderFns } from "./MonitorPointPalette.vue?vue&type=template&id=791f9ddd"
import script from "./MonitorPointPalette.vue?vue&type=script&lang=js"
export * from "./MonitorPointPalette.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports